import { Box } from '@mui/material';
import { ReactComponent as CompanyIcon } from 'assets/company-icon.svg';
import { useState } from 'react';
import zeplinColor from 'theme/Color';

const Logo = ({ logo }: { logo: string }) => {
  const [imageError, setImageError] = useState(false);

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        borderRadius: '8px',
        overflow: 'hidden',
        flexShrink: 0,
        backgroundColor: zeplinColor.Neutral1,
        border: `1px solid ${zeplinColor.Neutral5}`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
      }}
    >
      {logo && !imageError ? (
        <img
          src={logo}
          alt='company logo'
          width='100%'
          height='100%'
          style={{ objectFit: 'cover' }}
          onError={() => setImageError(true)}
        />
      ) : (
        <CompanyIcon width={'28px'} height={'28px'} />
      )}
    </Box>
  );
};

export default Logo;
